<template>
  <div class="flex flex-col gap-2 sm_gap-4">
    <LoginSocial @on-success="props.goToMeeting" />
    <div>
      <Button class="w-full" variant="outline" @click="onToggleLoginForm">Log in with Email</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['toggle-login-form'])

const props = defineProps<{
  meetingCode: string
  goToMeeting: () => void
}>()

const onToggleLoginForm = () => {
  emit('toggle-login-form')
}
</script>
